<template>
  <span
    class="ab-badge"
    :class="[`ab-badge--${status}`, `ab-badge--${services}`, `ab-badge--${size}`, caps ? 'ab-badge--upper' : 'ab-badge--lower', innerShadow ? 'ab-badge--inner-shadow' : '']"
    :style="{
      ...(variant === 'custom' ? {
        background: customBg || undefined,
        color: customColor || undefined,
        borderColor: customBorder || undefined
      } : {}),
      ...(!bold ? { fontWeight: 500 } : {})
    }"
    >
    <slot />
  </span>
</template>

<script>
export default {
  name: 'AppBadge',
  props: {
    status: {
      type: String,
      default: 'general',
      validator: v => ['general', 'active', 'pending', 'completed', 'inprogress', 'closed'].includes(v)
    },
    services: {
      type: String,
      default: '',
      validator: v => !v || ['tax', 'tp_reminder', 'cosec', 'Incorporation', 'payroll_yearly', 'payroll_reminder', 'payroll_monthly', 'sst', 'accounting'].includes(v)
    },
    variant: {
      type: String,
      default: 'custom',
      validator: v => ['custom'].includes(v)
    },
    customColor: { type: String, default: null },
    customBg: { type: String, default: null },
    customBorder: { type: String, default: null },
    size: {
      type: String,
      default: 'md',
      validator: v => ['sm', 'md', 'lg', 'xl'].includes(v)
    },
    caps: {
      type: Boolean,
      default: true
    },
    innerShadow: { type: Boolean, default: false },
    bold: { type: Boolean, default: true }
  }
}
</script>

<style scoped>
</style>
